import { z } from 'zod';

import {
  EmailSchema,
  toSnakeCase,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodCreateUserSchema = z
  .object({
    companyId: z.uuid(),
    email: EmailSchema,
    firstName: z.string().trim(),
    isActive: z.boolean(),
    isSynced: z.boolean().optional(),
    isVestigasSupport: z.boolean().prefault(false),
    lastName: z.string().trim(),
    notificationSettings: z
      .object({
        delayDuration: z.coerce.number().nonnegative().lte(60).optional(),
        sendEmail: z.boolean().optional(),
      })
      .optional(),
    orgUnits: z.array(z.uuid()).optional(),
    password: z.string().trim().min(8),
    permittedSignatureTypes: z.array(
      z.string().transform((value) => toSnakeCase(value)),
    ),
    position: z.union([z.literal(''), z.string().trim()]).optional(),
    syncKey: z.string().trim().nullish(),
    username: z.union([z.literal(''), z.string().trim()]).optional(),
    userType: z.union([z.literal(''), z.string()]).nullish(),
  })
  .transform((value) =>
    withoutObjectKeysWhereValueIs(value, [null, undefined]),
  );
